import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Whychoosegame() {
  return (
    <section
      className="why_choose_game_web3 p-100"
      style={{ background: "#F9F9F9" }}
    >
      <Container>
        <Row className="mt-3 mt-md-5">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>
              Why Choose TekRevol for <span>Web3 Game Development</span>
            </h2>
            <p>
              At TekRevol, you are more than a client with a brilliant idea for
              a Web3 game – you are a stakeholder and an equal partner in
              shaping our ‘why, what, and how’.  Here’s what we do when
              developing Web3 games:
            </p>
            <ul>
              <li>We ensure security and smart contract auditing</li>
              <li>
                We focus on blockchain-based, yet smooth player experience and
                accessibility
              </li>
              <li>We balance decentralization and performance</li>
              <li>We design features that engage individuals to communities</li>
            </ul>
            <div className="game_parcheesi mb-3 mb-md-0">
              <StaticImage
                src="../../images/services-usa/web3-game/why_choose_game.webp"
                alt="tekrevol_web"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={626}
                height={439}
              />
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
            <p>
              Our whys are deeply rooted in our mission to help global
              enterprises, startups, B2C and B2B corporates and solopreneurs
              achieve revenue goals and operational efficiency with digital
              transformation – and so, innovation, process automation, and love
              for emerging technologies are the strongest parts of our guiding
              principles.
            </p>
            <p>
              We are laser-focused on building mobile applications, games and
              SaaS programs that deliver experiences to end users – and these
              experiences go beyond the features of the mobile app.
            </p>
            <p>
              While we are a Web3{" "}
              <Link to="https://www.tekrevol.com/game-development">
                game development company
              </Link>
              , at heart, we want to help our clients navigate the evolving
              nature of technology so they can align their customers’ goals with
              their business revenue. We want to help gaming startups, founders
              and media companies embrace the cultural of technological change –
              for good – and we want to be their north star in their game
              development journeys.
            </p>
            <p>
              While this is our why, our how goes beyond the Web3 game
              development process we have shared earlier. We believe in
              transparency and give our clients a 24*7 access to a custom CRM
              dashboard that keeps you posted about the progress in your game
              development. While we do assign a dedicated project manager with
              each game, we do also work in three shifts and ensure a key
              account manager is always there to assist you with technical
              queries and project updates.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychoosegame;
